export default "__VITE_ASSET__a3e35034__"